import { graphql } from "gatsby"
import { gql } from "@apollo/client"

export const query = graphql`
  fragment landingPageEntry on Craft_pages_Landing_Entry {
    uid
    title

    pageHeaderTitle
    pageHeaderText
    pageHeaderImage {
      ...mainFileUploadsAsset
    }
    flipMask
    noMask

    contentBlocks {
      ...audienceCardsContentBlockType
      ...buttonsContentBlockType
      ...cardsBlockType
      ...ctaContentBlockType
      ...embeddedCodeBlockType
      ...faqListContentBlockType
      ...faqListContentBlockType
      ...featuredCardContentBlockType
      ...featuredCaseStudiesBlockType
      ...featuredEventsContentBlockType
      ...featuredResourcesBlockType
      ...fullImageContentBlockType
      ...iconBarContentBlockType
      ...latestResourcesBlockType
      ...profileListContentBlockType
      ...pullQuoteContentBlockType
      ...richContentContentBlockType
      ...sectionHeaderContentBlockType
      ...sponsorListContentBlockType
      ...statsContentBlockType
      ...testimonialListContentBlockType
      ...upcomingEventsContentBlockType
      ...videoContentBlockType
    }

    footerCTA {
      ...defaultCTAEntry
    }

    seomatic {
      ...entrySEO
    }
  }
`

export const landingPageEntry = gql`
  fragment landingPageEntry on pages_Landing_Entry {
    uid
    title

    pageHeaderTitle
    pageHeaderText
    pageHeaderImage {
      ...mainFileUploadsAsset
    }
    flipMask
    noMask

    contentBlocks {
      ...audienceCardsContentBlockType
      ...buttonsContentBlockType
      ...cardsBlockType
      ...ctaContentBlockType
      ...embeddedCodeBlockType
      ...faqListContentBlockType
      ...faqListContentBlockType
      ...featuredCardContentBlockType
      ...featuredCaseStudiesBlockType
      ...featuredEventsContentBlockType
      ...featuredResourcesBlockType
      ...fullImageContentBlockType
      ...iconBarContentBlockType
      ...latestResourcesBlockType
      ...profileListContentBlockType
      ...pullQuoteContentBlockType
      ...richContentContentBlockType
      ...sectionHeaderContentBlockType
      ...sponsorListContentBlockType
      ...statsContentBlockType
      ...testimonialListContentBlockType
      ...upcomingEventsContentBlockType
      ...videoContentBlockType
    }

    footerCTA {
      ...defaultCTAEntry
    }

    seomatic {
      ...entrySEO
    }
  }
`
